export const version = '2.23.2'
